module.exports = __webpack_public_path__ + "static/media/campus_taskflow.096ae78e.jpg";